import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createTypeCompanies,
  deleteTypeCompaniesById,
  getTypeCompaniesById,
  getTypeCompaniesList,
  updateTypeCompaniesById,
} from "./queries";

const TypeCompaniesContext = createContext({});

export const useTypeCompaniesContext = () => useContext(TypeCompaniesContext);

export const TypeCompaniesProvider = ({ ...props }) => {
  const [typeCompaniesList, setTypeCompaniesList] = useState([]);
  const [typeCompaniesPerId, setTypeCompaniesPerId] = useState({});

  const typeCompaniesListGetter = useCallback(async () => {
    try {
      if (typeCompaniesList.length === 0) {
        setTypeCompaniesList(await getTypeCompaniesList());
      }
    } catch (e) {
      console.error("typeCompaniesListGetter", e);
      throw e;
    }
  }, [typeCompaniesList]);

  const typeCompaniesByIdGetter = useCallback(
    async (id) => {
      try {
        setTypeCompaniesPerId(await getTypeCompaniesById(id));
      } catch (e) {
        console.error("typeCompaniesListGetter", e);
        throw e;
      }
    },
    [setTypeCompaniesPerId]
  );
  const typeCompaniesCreate = useCallback(async (data) => {
    try {
      const typeCompanies = await createTypeCompanies(data);
      setTypeCompaniesList((old) => [...old, typeCompanies]);
    } catch (e) {
      console.error("typeCompaniesCreate", e);
      throw e;
    }
  }, []);
  const typeCompaniesUpdateById = useCallback(async (id, data) => {
    try {
      const updatedTypeCompanies = await updateTypeCompaniesById(id, data);
      setTypeCompaniesPerId(updatedTypeCompanies);
      setTypeCompaniesList((old) =>
        old.map((elm) =>
          elm.id === updatedTypeCompanies.id ? updatedTypeCompanies : elm
        )
      );
    } catch (e) {
      console.error("typeCompaniesUpdateById", e);
      throw e;
    }
  }, []);

  const typeCompaniesDeleteById = useCallback(
    async (id) => {
      try {
        await deleteTypeCompaniesById(id);
        setTypeCompaniesList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("companiesDelete", e);
        throw e;
      }
    },
    [setTypeCompaniesList]
  );
  const values = useMemo(
    () => ({
      typeCompaniesList,
      typeCompaniesListGetter,
      typeCompaniesByIdGetter,
      typeCompaniesDeleteById,
      typeCompaniesCreate,
      typeCompaniesUpdateById,
      typeCompaniesPerId,
      setTypeCompaniesPerId,
    }),
    [
      typeCompaniesList,
      typeCompaniesListGetter,
      typeCompaniesByIdGetter,
      typeCompaniesDeleteById,
      typeCompaniesCreate,
      typeCompaniesUpdateById,
      typeCompaniesPerId,
      setTypeCompaniesPerId,
    ]
  );
  return <TypeCompaniesContext.Provider value={values} {...props} />;
};
